var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.77,169.51c-.72,0-1.3-7.56-1.3-16.89s.58-16.89,1.3-16.89,1.31,7.56,1.31,16.89S59.49,169.51,58.77,169.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.46,160.19c-.72,0-1.3-3.6-1.3-8s.58-8,1.3-8,1.3,3.6,1.3,8S50.18,160.19,49.46,160.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.11,157.59c-.71,0-1.39-1.82-1.5-4.15s.38-4.23,1.09-4.27,1.4,1.82,1.51,4.15S40.83,157.55,40.11,157.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,161.32c-.72,0-1.21-4.32-1.11-9.63s.77-9.6,1.49-9.58,1.22,4.32,1.11,9.63S69.22,161.34,68.5,161.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.08,157.79c-.72,0-1.31-1.88-1.31-4.2s.59-4.21,1.31-4.21,1.3,1.88,1.3,4.21S79.8,157.79,79.08,157.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,153.59s0-.19,0-.54-.06-.91-.11-1.59c0-.35,0-.74-.07-1.17s-.14-.89-.21-1.4a23.87,23.87,0,0,0-.7-3.44,31.69,31.69,0,0,0-3.71-8.87,33.47,33.47,0,0,0-22.46-15.64,32.12,32.12,0,0,0-4.2-.48c-.72,0-1.44-.1-2.17-.08l-2.2.11c-.37,0-.74,0-1.11.07l-1.11.17c-.74.13-1.49.21-2.23.37a34.34,34.34,0,0,0-4.43,1.3,33.68,33.68,0,0,0-4.33,1.9c-.7.38-1.37.82-2.07,1.24a16.57,16.57,0,0,0-2,1.38,35.36,35.36,0,0,0-3.76,3.2A36.8,36.8,0,0,0,32,134a32.14,32.14,0,0,0-4.74,9.14,32.94,32.94,0,0,0,0,20.95A32.08,32.08,0,0,0,32,173.21a37.65,37.65,0,0,0,3.25,3.84,37.88,37.88,0,0,0,3.77,3.21,19.23,19.23,0,0,0,2,1.38c.7.41,1.37.85,2.07,1.23a35.2,35.2,0,0,0,4.33,1.91,36,36,0,0,0,4.43,1.3c.74.15,1.5.24,2.24.36l1.1.17c.37,0,.74,0,1.11.08l2.2.11c.73,0,1.45-.06,2.17-.08a30.31,30.31,0,0,0,4.2-.49,33.39,33.39,0,0,0,22.46-15.64,31.77,31.77,0,0,0,3.71-8.86,23.72,23.72,0,0,0,.7-3.45c.07-.5.17-1,.21-1.4s.05-.81.07-1.16c0-.69.08-1.21.11-1.59s0-.54,0-.54,0,.18,0,.54,0,.91,0,1.59c0,.35,0,.75,0,1.18s-.12.89-.19,1.4a23.36,23.36,0,0,1-.65,3.48,31.88,31.88,0,0,1-3.66,9A33.62,33.62,0,0,1,65,186.66a31.19,31.19,0,0,1-4.26.5c-.72,0-1.45.1-2.19.09l-2.23-.11c-.37,0-.75,0-1.13-.07l-1.12-.17c-.75-.12-1.51-.21-2.27-.36a35.23,35.23,0,0,1-4.49-1.31,36.19,36.19,0,0,1-4.4-1.92c-.71-.39-1.4-.84-2.1-1.25a17.55,17.55,0,0,1-2-1.4,37.73,37.73,0,0,1-3.82-3.25,37.64,37.64,0,0,1-3.31-3.9,32.84,32.84,0,0,1-4.83-9.29,33.28,33.28,0,0,1,0-21.27,32.56,32.56,0,0,1,4.82-9.29,37.64,37.64,0,0,1,3.31-3.9,37.63,37.63,0,0,1,3.82-3.24,17.55,17.55,0,0,1,2-1.4c.71-.42,1.39-.87,2.1-1.25A34.7,34.7,0,0,1,47.3,122a35.23,35.23,0,0,1,4.49-1.31c.76-.16,1.52-.24,2.27-.37l1.12-.17c.38,0,.75,0,1.13-.07l2.23-.11c.73,0,1.47.07,2.19.09a32.84,32.84,0,0,1,4.26.51,33.63,33.63,0,0,1,22.63,15.91,31.92,31.92,0,0,1,3.66,9,23.49,23.49,0,0,1,.65,3.47c.07.51.15,1,.19,1.41s0,.82,0,1.17c0,.69,0,1.22,0,1.6S92.22,153.59,92.22,153.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9,82.34h0a14.48,14.48,0,0,1-14.48-14.48v-17A14.48,14.48,0,0,1,297.9,36.37h0a14.48,14.48,0,0,1,14.48,14.48v17A14.48,14.48,0,0,1,297.9,82.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9,91.16a21.4,21.4,0,0,1-21.38-21.38h2.07A19.33,19.33,0,0,0,297.9,89.09c11.36,0,19.3-8,19.3-19.31h2.08C319.28,82.36,310.48,91.15,297.9,91.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.86,
    y: 90.12,
    width: 2.07,
    height: 10.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.26,
    y: 99.09,
    width: 25.28,
    height: 2.07,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.55,45.84a11.57,11.57,0,0,1-3.74-1.19c-3.08-1.31-4.12-2-3.75-3.08l.14-.43.49-.25c1.08-.49,3.82.64,4.35.87s3.25,1.42,3.65,2.54l.15.42-.21.5h0A1.09,1.09,0,0,1,276.55,45.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.82,35c-.66,0-1.66-.74-3.74-3.56-2.47-3.36-2.35-4.17-2.3-4.44l.06-.42.73-.58.49.05c.27,0,1.09.17,3.55,3.52,2.89,3.92,2.56,4.66,1.86,5.17h0A1.09,1.09,0,0,1,284.82,35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,31.08l-.4-.34c-.2-.19-.79-.75-.75-4.7s.65-4.5.85-4.69l.34-.3h.52c.63.05,1.5.12,1.44,5s-.92,4.95-1.55,5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.28,33.89l-.43-.34c-.91-.84-.09-2,1.69-4.41s2.7-3.49,3.77-2.85l.4.24.14.54c.25,1.23-1.58,3.69-1.79,4s-2.07,2.71-3.31,2.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.65,45.68a1,1,0,0,1-1-.58c-.56-1,.51-1.81,1-2.21A21.87,21.87,0,0,1,322,41.35c3.84-2.18,4.55-1.69,4.94-1,.56,1-.51,1.81-1,2.21a20.5,20.5,0,0,1-2.35,1.53C321.5,45.29,320.34,45.68,319.65,45.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,468c-17.71-8-25-27.71-27.82-46.11-.47-3.07-1.4-6.22-.45-9.17s4-5.4,7-4.62c2.46.64,3.94,3.09,5.61,5a18,18,0,0,0,8.42,5.5c2.13.65,4.65.82,6.37-.59,2.37-1.94,2-5.64,1.42-8.67q-1.63-8.47-3.26-16.95a28.78,28.78,0,0,1-.76-9.18c.41-3.05,2-6.12,4.74-7.46s6.61-.35,7.77,2.51a27.89,27.89,0,0,1,.79,3.76c.32,1.25,1.17,2.53,2.43,2.66s2.33-1,3.07-2c2.56-3.65,4-8,5.21-12.28s2.44-8.67,4.66-12.54,5.66-7.25,10-8.3,9.43.76,11.32,4.83.21,8.87-1.86,12.84A69,69,0,0,1,391,383.34a5.66,5.66,0,0,0-1.89,3c-.28,2.15,2,3.8,4.13,4.09,2.4.34,4.81-.35,7.23-.52s5.18.41,6.49,2.48c1.82,2.87-.17,6.6-2.33,9.21a59.18,59.18,0,0,1-15.33,13.1c-2.08,1.23-4.3,2.39-5.81,4.29s-2.09,4.83-.6,6.77,4.4,2.1,6.66,1.23,4.11-2.53,6.19-3.78c3.87-2.35,9.31-3.06,12.65.05a9.73,9.73,0,0,1,2.6,8.3,22.53,22.53,0,0,1-3.2,8.35A59.34,59.34,0,0,1,386.14,462c-9.05,5.15-17.84,7.72-28.11,6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.56,471.33c-.68-7.37.06-5.93,1.06-15.65A275.52,275.52,0,0,1,366,424.4c.61-2.74,1.22-5.46,1.82-8.13s1.21-5.31,1.95-7.86a139.3,139.3,0,0,1,5.13-14.4c1.86-4.51,3.78-8.71,5.6-12.63s3.62-7.54,5.38-10.77a109.78,109.78,0,0,1,9.45-14.6c1.24-1.63,2.25-2.86,2.94-3.69l.8-.94a1.88,1.88,0,0,1,.29-.3,3.64,3.64,0,0,1-.25.34c-.18.24-.43.57-.75,1-.66.85-1.64,2.11-2.86,3.76a115.81,115.81,0,0,0-9.26,14.66c-1.74,3.23-3.5,6.85-5.31,10.77s-3.71,8.13-5.55,12.63a140.24,140.24,0,0,0-5.07,14.36c-.74,2.54-1.33,5.16-1.94,7.83s-1.2,5.38-1.82,8.13a282.48,282.48,0,0,0-5.39,31.21c-1,9.68-1.81,8.21-1.18,15.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,408.36a5.92,5.92,0,0,1-.54-1.24c-.31-.81-.73-2-1.22-3.46-1-3-2.22-7.06-3.56-11.59s-2.62-8.62-3.66-11.54c-.51-1.46-.93-2.64-1.24-3.45a5.81,5.81,0,0,1-.41-1.28,6.36,6.36,0,0,1,.61,1.2c.37.79.86,1.95,1.42,3.39,1.13,2.9,2.48,7,3.82,11.52s2.49,8.53,3.4,11.62c.41,1.4.77,2.58,1.05,3.52A5.81,5.81,0,0,1,369.91,408.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,393.82a8.33,8.33,0,0,1-1.52.48c-1,.27-2.41.66-4.16,1.2-3.5,1.05-8.29,2.67-13.49,4.69s-9.83,4.06-13.14,5.63c-1.65.77-3,1.43-3.9,1.88a7.91,7.91,0,0,1-1.45.66,8.3,8.3,0,0,1,1.35-.85c.89-.52,2.19-1.24,3.83-2.06,3.27-1.66,7.89-3.77,13.1-5.8a140.46,140.46,0,0,1,13.59-4.54c1.76-.49,3.21-.82,4.22-1A8.69,8.69,0,0,1,407.57,393.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,454.87s-.14-.13-.36-.42l-.93-1.29c-.8-1.12-1.92-2.78-3.27-4.84-2.72-4.12-6.28-9.93-10.13-16.39s-7.37-12.3-10-16.47l-3.12-4.93-.84-1.35a1.75,1.75,0,0,1-.26-.49,2.3,2.3,0,0,1,.35.43c.26.35.56.77.93,1.29.81,1.12,1.92,2.77,3.28,4.83,2.71,4.12,6.28,9.93,10.13,16.4s7.36,12.29,10,16.46l3.12,4.93.85,1.35A2.91,2.91,0,0,1,361,454.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.71,428.53a1.9,1.9,0,0,1-.48.31l-1.41.78-5.22,2.83c-4.4,2.4-10.45,5.77-17.12,9.5s-12.77,7.06-17.22,9.36c-2.23,1.15-4,2.06-5.31,2.67l-1.46.69a1.82,1.82,0,0,1-.52.2,2,2,0,0,1,.47-.31l1.41-.78,5.22-2.83c4.41-2.39,10.45-5.76,17.13-9.5s12.76-7.06,17.21-9.36c2.23-1.15,4-2.06,5.31-2.66l1.46-.69A2.28,2.28,0,0,1,409.71,428.53Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.42,471.28c0,.15-103.62.26-231.41.26s-231.43-.11-231.43-.26S122.18,471,250,471,481.42,471.14,481.42,471.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.23,442c1-4.14-1.69-8.27-4.74-11.25s-6.7-5.65-8.31-9.61c-2.59-6.4.8-14.74-3.6-20.08-2.58-3.13-7.2-4.16-9.5-7.52a17.15,17.15,0,0,1-2.09-6,61.18,61.18,0,0,0-15.36-28.37,53,53,0,0,0,6.12,27.39c1.79,3.36,4,6.63,4.59,10.39,1,6.1-2.39,12.41-.86,18.39,1.76,6.85,9.49,11.4,9.89,18.45.34,6-4.83,11.24-4.41,17.2a16.13,16.13,0,0,0,2.7,7.06c4.66,7.64,11.47,12.89,21.74,12.66L85,471Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.23,442c1-4.14-1.69-8.27-4.74-11.25s-6.7-5.65-8.31-9.61c-2.59-6.4.8-14.74-3.6-20.08-2.58-3.13-7.2-4.16-9.5-7.52a17.15,17.15,0,0,1-2.09-6,61.18,61.18,0,0,0-15.36-28.37,53,53,0,0,0,6.12,27.39c1.79,3.36,4,6.63,4.59,10.39,1,6.1-2.39,12.41-.86,18.39,1.76,6.85,9.49,11.4,9.89,18.45.34,6-4.83,11.24-4.41,17.2a16.13,16.13,0,0,0,2.7,7.06c4.66,7.64,11.47,12.89,21.74,12.66L85,471Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M87.53,471.35s.31,0,.88,0A15.9,15.9,0,0,0,91,471.1,22.23,22.23,0,0,0,95,470a17.06,17.06,0,0,0,4.91-2.81,6.64,6.64,0,0,0,1.94-2.66,12.84,12.84,0,0,0,.52-3.66,35.14,35.14,0,0,1,.24-4.12,11.58,11.58,0,0,1,1.53-4.21c1.5-2.69,3.88-5.15,4.59-8.54s.16-7-.47-10.82-1.26-8,.2-12.11,4.09-7.66,5.37-11.95.63-9.05.88-13.91a19.46,19.46,0,0,1,1.64-7.25c1-2.31,2.44-4.42,3.49-6.71,2.12-4.59,2.49-9.88,3.06-15.17.28-2.65.56-5.34.85-8.05a39.6,39.6,0,0,1,1.37-8.19,70.91,70.91,0,0,1,3-7.89,24.56,24.56,0,0,0,1.39-3.93,40.48,40.48,0,0,0,.37-4.2,50.45,50.45,0,0,0-.38-8.58c-.36-2.87-.9-5.75-1.23-8.69,0-.17,0-.35-.06-.51l.57.32a18.69,18.69,0,0,0-6.46,5.52,30.54,30.54,0,0,0-4,7.49c-2,5.31-2.76,10.92-3.8,16.36s-2.37,10.87-5.2,15.51c-1.41,2.3-3.07,4.36-4.5,6.51a17.14,17.14,0,0,0-3,6.88c-.73,5,2.21,9.64,1.63,14.67a17.17,17.17,0,0,1-2.36,6.81c-1.17,2.06-2.52,3.94-3.78,5.81A36.17,36.17,0,0,0,94,407.6a17.87,17.87,0,0,0-1.48,6.11c-.3,4.15.31,8.18,0,12.07a28.39,28.39,0,0,1-3.15,10.54c-1.54,3.12-3.23,5.92-4.65,8.62a43,43,0,0,0-1.89,4,18.61,18.61,0,0,0-1.09,3.89,24.56,24.56,0,0,0-.12,7.08A18.23,18.23,0,0,0,85.08,469a15.63,15.63,0,0,0,2.45,2.39s-.25-.15-.72-.5a5,5,0,0,1-.83-.69,9.35,9.35,0,0,1-1-1.1,18,18,0,0,1-3.65-9.14,24.74,24.74,0,0,1,0-7.18,19.59,19.59,0,0,1,1.08-4,43.83,43.83,0,0,1,1.89-4c1.4-2.72,3.08-5.53,4.58-8.63a27.89,27.89,0,0,0,3-10.36c.29-3.81-.34-7.83,0-12.07a18.2,18.2,0,0,1,1.51-6.32,37.3,37.3,0,0,1,3.34-5.83c1.26-1.88,2.6-3.75,3.73-5.77a16.46,16.46,0,0,0,2.26-6.54c.58-4.72-2.38-9.38-1.66-14.7a17.71,17.71,0,0,1,3.08-7.19c1.44-2.2,3.1-4.25,4.47-6.5,2.74-4.51,4.08-9.84,5.08-15.25s1.76-11.08,3.83-16.5a30.94,30.94,0,0,1,4.12-7.7,19.34,19.34,0,0,1,6.74-5.75l.51-.26.06.58c0,.15,0,.33.06.5.33,2.91.87,5.78,1.23,8.68a50.9,50.9,0,0,1,.38,8.71,40,40,0,0,1-.38,4.33,26.18,26.18,0,0,1-1.43,4.08,70,70,0,0,0-3,7.8,39.36,39.36,0,0,0-1.35,8.06q-.43,4.06-.86,8c-.58,5.26-.94,10.64-3.15,15.39-1.09,2.35-2.49,4.46-3.5,6.7a18.66,18.66,0,0,0-1.6,7c-.26,4.76.41,9.57-.94,14.06s-4.09,8-5.42,12-.83,8.05-.23,11.82,1.25,7.55.41,11-3.23,6-4.7,8.64A11.16,11.16,0,0,0,103,456.8a35.65,35.65,0,0,0-.27,4.07,13.2,13.2,0,0,1-.57,3.76,7.16,7.16,0,0,1-2.06,2.78,17.59,17.59,0,0,1-5,2.8A21.17,21.17,0,0,1,91,471.26,9.9,9.9,0,0,1,87.53,471.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,322.88a1.35,1.35,0,0,1,0,.4c-.06.3-.12.68-.2,1.15-.19,1-.42,2.49-.85,4.41s-1.54,4.07-2.45,6.66-1.93,5.58-2.82,8.94-1.69,7.07-2.53,11.08-1.75,8.38-3.95,12.5c-1,2.07-2.15,4.14-3,6.35a29,29,0,0,0-1.71,7.06,145,145,0,0,1-2.62,15.3l-7,29.12-6,23.71c-1.73,6.69-3.13,12.13-4.11,16L88,469.86c-.13.45-.23.82-.32,1.12s-.12.38-.14.37a2,2,0,0,1,.06-.39q.1-.45.24-1.14c.25-1.06.59-2.52,1-4.37l3.87-16c1.66-6.78,3.64-14.82,5.83-23.75s4.48-18.79,6.95-29.11a146.08,146.08,0,0,0,2.62-15.24,30,30,0,0,1,1.77-7.23c.91-2.27,2.06-4.35,3.08-6.4,2.18-4,3.07-8.32,4-12.31s1.7-7.73,2.64-11.09,1.94-6.36,2.94-8.94,2.09-4.73,2.57-6.59.75-3.37,1-4.36l.27-1.14A2.25,2.25,0,0,1,126.45,322.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,471.38c8.19-4.93,10.46-19.78,7-28.68s-9.52-17-10.5-26.54c-.76-7.31,1.6-14.84-.15-22-2.35-9.63-11.82-17.05-11.76-27,0-5.57,3.16-10.83,2.88-16.38-.35-6.82-5.61-12.2-8.89-18.19-5-9.17-5.4-20-7.16-30.34S55.41,281,46.25,276c-1.3,8.76-3.57,14.77-2.78,26.63.28,4.25,5.28,12.38,6,21.71.44,5.57.75,11.16,1.12,16.74.36,5.43.74,11,2.72,16,1.52,3.89,3.93,7.42,5.06,11.43,2.13,7.55-.56,15.76,1.17,23.42,1.46,6.49,6,12.05,6.94,18.63,1.34,9.24-4.59,18.89-1.47,27.7,1.54,4.37,5.16,7.86,6.21,12.38.81,3.5,0,7.22.71,10.74,1.19,5.68,12,10,17.83,9.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.56,284.64a2.78,2.78,0,0,1,.12.48c.07.36.16.83.27,1.42.25,1.25.53,3.12,1,5.48s1.8,5,2.86,8.32A116.32,116.32,0,0,1,56,311.59c1,4.22,1.85,8.89,2.73,13.9s1.81,10.38,4.32,15.52c1.17,2.6,2.5,5.23,3.51,8.09a36.74,36.74,0,0,1,1.85,9A182.24,182.24,0,0,0,71,377.22c2.57,12.95,5,25.29,7.24,36.52s4.37,21.29,6.12,29.78,3.09,15.3,4.06,20.1c.45,2.34.81,4.17,1.06,5.47.11.59.19,1.06.26,1.43a3,3,0,0,1,.06.49,2,2,0,0,1-.14-.47c-.09-.36-.2-.83-.34-1.42-.29-1.29-.69-3.11-1.21-5.44l-4.31-20c-1.79-8.49-3.92-18.56-6.28-29.75l-7.31-36.53a181.21,181.21,0,0,1-2.52-19.14,35.89,35.89,0,0,0-1.78-8.87c-1-2.8-2.3-5.42-3.46-8-2.53-5.21-3.43-10.72-4.31-15.7s-1.66-9.68-2.62-13.89-2-8-3.08-11.24-2.27-6-2.75-8.4-.66-4.25-.86-5.51l-.19-1.44A2.57,2.57,0,0,1,48.56,284.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,416.34a10.31,10.31,0,0,1,5.33,6,18.19,18.19,0,0,1,.71,8.17c-.61,5.3-3.62,10.65-6.86,14.89-4.47-3.89-5.5-10.69-5.8-14.18-.48-5.5,2-15.74,6.62-14.92",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.53,454.2a8.76,8.76,0,0,1,2.83-8.34,11.63,11.63,0,0,1,8.59-2.68,4.92,4.92,0,0,1,3.77,1.69,3.77,3.77,0,0,1,.06,3.8,7.65,7.65,0,0,1-2.82,2.77c-3.87,2.43-8.06,4.07-12.43,2.76",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,470.46a5.29,5.29,0,0,1,.16-1.09c.14-.77.32-1.76.54-2.95a30.83,30.83,0,0,1,3-9.41,18.92,18.92,0,0,1,6.75-7.17,13,13,0,0,1,2.75-1.22,7.6,7.6,0,0,1,.8-.2.85.85,0,0,1,.28,0,20.24,20.24,0,0,0-3.69,1.69,19.46,19.46,0,0,0-6.55,7.13,32.94,32.94,0,0,0-3.11,9.28c-.27,1.23-.49,2.23-.66,2.92A5.32,5.32,0,0,1,355.8,470.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,424.31a2.48,2.48,0,0,1,0,.47c0,.35.05.81.08,1.37.07,1.19.14,2.91.21,5,.13,4.25.24,10.12.21,16.61s-.18,12.36-.36,16.61c-.08,2.12-.17,3.84-.24,5,0,.56-.07,1-.1,1.37a2.48,2.48,0,0,1-.05.47,1.75,1.75,0,0,1,0-.48c0-.35,0-.81,0-1.37,0-1.23.07-2.94.12-5,.1-4.25.22-10.12.25-16.6s0-12.35-.11-16.6c0-2.09-.06-3.8-.08-5v-1.37A2.42,2.42,0,0,1,356,424.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.8,457.42a20.53,20.53,0,0,0-11.2-15c-1.49-.72-3.44-1.18-4.67-.07s-.95,3.1-.35,4.65a17.53,17.53,0,0,0,16.11,10.88",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,447.43a5.06,5.06,0,0,1,.95.41,11.8,11.8,0,0,1,1.07.57c.4.25.89.5,1.37.86a19.18,19.18,0,0,1,1.56,1.17,22.28,22.28,0,0,1,1.66,1.51,23,23,0,0,1,3.15,4.05,22.49,22.49,0,0,1,2.08,4.7,20.66,20.66,0,0,1,.52,2.18,16.65,16.65,0,0,1,.27,1.94,15.59,15.59,0,0,1,.07,1.6,7.74,7.74,0,0,1,0,1.22,4.61,4.61,0,0,1-.12,1c-.08,0,.07-1.47-.19-3.82-.08-.58-.15-1.22-.31-1.9s-.34-1.39-.55-2.13a24.05,24.05,0,0,0-2.07-4.61,23.57,23.57,0,0,0-3.08-4,20.12,20.12,0,0,0-1.61-1.51c-.51-.47-1-.84-1.51-1.2C344.63,448.12,343.29,447.5,343.32,447.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.09,471.28l-143.38-.66a31.24,31.24,0,0,1-31.09-31.37L84.14,79.8a31.23,31.23,0,0,1,31.38-31.1l143.38.66A31.23,31.23,0,0,1,290,80.73l-1.52,359.45A31.23,31.23,0,0,1,257.09,471.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.69,61.77l-27.8-.13a6.91,6.91,0,0,0-6.78,7l0,5a6.9,6.9,0,0,1-6.78,7l-54.18-.25a6.9,6.9,0,0,1-6.72-7.09l0-5a6.93,6.93,0,0,0-6.72-7.09l-9.78,0-24.33-.11a21.88,21.88,0,0,0-22,21.78L92.14,433.74a21.88,21.88,0,0,0,21.77,22l143.1.66a21.88,21.88,0,0,0,22-21.78l1.48-350.86A21.87,21.87,0,0,0,258.69,61.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6,328.11c.14,0,.26,8.82.26,19.69s-.12,19.7-.26,19.7-.26-8.82-.26-19.7S187.46,328.11,187.6,328.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,332.44c.14,0,.26,6.73.26,15s-.12,15-.26,15-.26-6.73-.26-15S182.32,332.44,182.47,332.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,336.74c.14,0,.26,4.87.26,10.88s-.12,10.89-.26,10.89-.26-4.87-.26-10.89S176.55,336.74,176.69,336.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,340.44a68.37,68.37,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,343.4a21.52,21.52,0,0,1,0,6.67,21.52,21.52,0,0,1,0-6.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.18,339.85a71,71,0,0,1,0,12.14,68.37,68.37,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44,335c.14,0,.26,5.1.26,11.4s-.12,11.41-.26,11.41-.27-5.11-.27-11.41S157.29,335,157.44,335Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.54,336.74c.14,0,.26,4.87.26,10.88s-.12,10.89-.26,10.89-.26-4.87-.26-10.89S217.4,336.74,217.54,336.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5,340.44a71,71,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,343.4a21.52,21.52,0,0,1,0,6.67,21.52,21.52,0,0,1,0-6.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,338.07a57.07,57.07,0,0,1,.27,7.85,57.07,57.07,0,0,1-.27,7.85,60.17,60.17,0,0,1-.26-7.85A60.17,60.17,0,0,1,203,338.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,335c.15,0,.27,5.1.27,11.4s-.12,11.41-.27,11.41-.26-5.11-.26-11.41S198.14,335,198.28,335Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.51,332.59c.14,0,.26,6.5.26,14.51s-.12,14.52-.26,14.52-.26-6.5-.26-14.52S192.36,332.59,192.51,332.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.92,352a71,71,0,0,1,0-12.14,71,71,0,0,1,0,12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.37,349a21.52,21.52,0,0,1,0-6.67,21.52,21.52,0,0,1,0,6.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,339.85a71,71,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.35,342.81a21.45,21.45,0,0,1,0,6.66,21.45,21.45,0,0,1,0-6.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.92,339.85a71,71,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18,335c.14,0,.26,5.1.26,11.4s-.12,11.41-.26,11.41-.26-5.11-.26-11.41S139,335,139.18,335Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,339.85a71,71,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.1,342.81a21.45,21.45,0,0,1,0,6.66,21.45,21.45,0,0,1,0-6.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,339.85a71,71,0,0,1,0,12.14,71,71,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,335c.15,0,.26,5.1.26,11.4s-.11,11.41-.26,11.41-.26-5.11-.26-11.41S236.57,335,236.71,335Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,339.85a71,71,0,0,1,0,12.14,68.37,68.37,0,0,1,0-12.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,342.81a21.45,21.45,0,0,1,0,6.66,21.45,21.45,0,0,1,0-6.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,342.81a21.45,21.45,0,0,1,0,6.66,21.45,21.45,0,0,1,0-6.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.83,203.24s0-.42-.06-1.24,0-2-.16-3.63a77.21,77.21,0,0,0-2.19-13.76,75.18,75.18,0,0,0-3.13-9.58A74.42,74.42,0,0,0,254,164.3a77.1,77.1,0,0,0-19.36-21.63,76.11,76.11,0,0,0-32.06-14.22,75.77,75.77,0,0,0-19.62-1.07,76.56,76.56,0,0,0-10.19,1.42,80.81,80.81,0,0,0-10.18,2.91,76.27,76.27,0,0,0-35.36,26.52,74.83,74.83,0,0,0-6.2,10c-.94,1.74-1.74,3.56-2.56,5.38s-1.49,3.7-2.09,5.62a76.62,76.62,0,0,0-3.9,24,81.74,81.74,0,0,0,1,12.25,73,73,0,0,0,2.89,11.77c.61,1.92,1.36,3.77,2.1,5.62s1.61,3.64,2.55,5.38a76.15,76.15,0,0,0,41.57,36.52,80.81,80.81,0,0,0,10.18,2.91,77.82,77.82,0,0,0,29.82.35,76,76,0,0,0,32.05-14.22A77,77,0,0,0,254,242.16a73.41,73.41,0,0,0,5.31-10.73,74.71,74.71,0,0,0,3.14-9.57,77.93,77.93,0,0,0,2.18-13.76c.14-1.59.11-2.81.16-3.63s.06-1.23.06-1.23,0,.41,0,1.23,0,2-.11,3.64a75,75,0,0,1-2.09,13.8,76.61,76.61,0,0,1-8.39,20.4,77.17,77.17,0,0,1-19.38,21.78,75.25,75.25,0,0,1-14.61,8.77,74.44,74.44,0,0,1-17.59,5.58,76.24,76.24,0,0,1-19.74,1.11,77.81,77.81,0,0,1-10.26-1.42,81.67,81.67,0,0,1-10.24-2.91,76.76,76.76,0,0,1-35.62-26.69,75.75,75.75,0,0,1-6.24-10.05c-1-1.76-1.75-3.59-2.58-5.42s-1.5-3.73-2.11-5.66a74.86,74.86,0,0,1-2.92-11.85,82.8,82.8,0,0,1-1-12.33,77.4,77.4,0,0,1,3.92-24.17c.61-1.93,1.38-3.79,2.12-5.66s1.63-3.65,2.57-5.41a74.79,74.79,0,0,1,6.25-10,76.71,76.71,0,0,1,35.61-26.68,81.67,81.67,0,0,1,10.24-2.91,77.58,77.58,0,0,1,10.26-1.42A76.13,76.13,0,0,1,202.64,128a76.2,76.2,0,0,1,32.2,14.34,77.35,77.35,0,0,1,19.39,21.78,73.69,73.69,0,0,1,5.29,10.79,75.68,75.68,0,0,1,3.1,9.62,74.88,74.88,0,0,1,2.09,13.8c.13,1.6.08,2.82.11,3.64S264.83,203.24,264.83,203.24Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.16,201.59s0-.36,0-1.07,0-1.76-.15-3.13a65.85,65.85,0,0,0-25.88-48,65.57,65.57,0,0,0-27.65-12.25,65.75,65.75,0,0,0-16.92-.93,67.21,67.21,0,0,0-8.8,1.23,70.19,70.19,0,0,0-8.77,2.51,65.77,65.77,0,0,0-35.85,31.49,62.54,62.54,0,0,0-4,9.48,65.69,65.69,0,0,0,0,41.42,60.68,60.68,0,0,0,4,9.49,64.23,64.23,0,0,0,5.35,8.61,65.81,65.81,0,0,0,30.5,22.89,70.63,70.63,0,0,0,8.77,2.5,65.55,65.55,0,0,0,8.8,1.23,64.85,64.85,0,0,0,16.92-.93,65.57,65.57,0,0,0,27.65-12.25A65.77,65.77,0,0,0,255,205.78c.13-1.37.1-2.42.15-3.13s0-1.06,0-1.06,0,1.45-.09,4.2a65,65,0,0,1-9,29.53,66.73,66.73,0,0,1-16.72,18.8,65.8,65.8,0,0,1-27.8,12.39,67.06,67.06,0,0,1-25.89-.27,71.21,71.21,0,0,1-8.84-2.51,66.21,66.21,0,0,1-30.75-23,64.05,64.05,0,0,1-5.4-8.68,61.17,61.17,0,0,1-4-9.56,66.12,66.12,0,0,1,0-41.74,61.22,61.22,0,0,1,4-9.56,65.53,65.53,0,0,1,5.39-8.67,66.19,66.19,0,0,1,30.75-23,69.52,69.52,0,0,1,8.84-2.51,64.69,64.69,0,0,1,8.85-1.23,65.76,65.76,0,0,1,17,1,65.84,65.84,0,0,1,27.79,12.38A66.62,66.62,0,0,1,246,167.85a65,65,0,0,1,9,29.53C255.2,200.14,255.16,201.59,255.16,201.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.52,
    cy: 203.24,
    r: 54.21,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.27,
    y: 186.78,
    width: 14.33,
    height: 22.75,
    rx: 6.64,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,213.87a10.58,10.58,0,0,1-10.56-10.56.5.5,0,0,1,1,0,9.57,9.57,0,0,0,9.56,9.56,9.16,9.16,0,0,0,9.57-9.56.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5C199,209.52,194.65,213.86,188.43,213.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.93,
    y: 213.36,
    width: 1,
    height: 5.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,218.82H182.18a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h12.51a.5.5,0,0,1,.5.5A.51.51,0,0,1,194.69,218.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,190.92c-.06.13-.82-.14-1.72-.52s-1.62-.75-1.58-.89.86,0,1.78.41S178,190.79,178,190.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,185.56c-.11.09-.76-.6-1.45-1.53s-1.15-1.76-1-1.84.76.6,1.45,1.53S182.1,185.48,182,185.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,183.64c-.15,0-.25-.87-.24-2s.14-2,.28-2a7.56,7.56,0,0,1,0,3.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,182.23c.12.08-.19.82-.77,1.6s-1.22,1.28-1.32,1.18.33-.74.9-1.5S196.66,182.16,196.79,182.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,189c.07.13-.6.64-1.49,1.15s-1.67.81-1.74.69.59-.64,1.48-1.15S202.31,188.88,202.38,189Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,309.87l-1.6-2.31h-1.77v2.31H141.5v-8.31h3.6c2.22,0,3.61,1.16,3.61,3A2.69,2.69,0,0,1,147,307.2l1.86,2.67ZM145,303.13h-1.56V306H145c1.18,0,1.77-.55,1.77-1.45S146.17,303.13,145,303.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.32,307.2h-4.83a1.7,1.7,0,0,0,1.83,1.29,2.19,2.19,0,0,0,1.6-.62l1,1.07a3.39,3.39,0,0,1-2.64,1,3.31,3.31,0,0,1-3.64-3.29,3.25,3.25,0,0,1,3.4-3.29,3.16,3.16,0,0,1,3.33,3.31C156.36,306.85,156.33,307.05,156.32,307.2Zm-4.85-1.08h3.14a1.59,1.59,0,0,0-3.14,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07,306.23v3.64h-1.74v-.79a2.09,2.09,0,0,1-1.94.89c-1.5,0-2.39-.83-2.39-1.94s.8-1.91,2.74-1.91h1.47c0-.79-.47-1.26-1.47-1.26a3.09,3.09,0,0,0-1.84.6l-.66-1.3a5,5,0,0,1,2.75-.77C161.94,303.39,163.07,304.3,163.07,306.23Zm-1.86,1.63v-.66h-1.27c-.86,0-1.14.32-1.14.75s.4.77,1,.77A1.35,1.35,0,0,0,161.21,307.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,301.07v8.8h-1.77v-.73a2.44,2.44,0,0,1-2,.83,3.29,3.29,0,0,1,0-6.58,2.47,2.47,0,0,1,1.91.77v-3.09Zm-1.82,5.61a1.64,1.64,0,1,0-1.62,1.77A1.62,1.62,0,0,0,169.5,306.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.37,303.49l-2.89,6.78a2.62,2.62,0,0,1-2.64,2,2.8,2.8,0,0,1-1.78-.58l.67-1.32a1.67,1.67,0,0,0,1.05.41c.51,0,.79-.23,1-.8l0-.06-2.77-6.43H174l1.79,4.33,1.81-4.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,309.57a2.68,2.68,0,0,1-1.51.4,2.1,2.1,0,0,1-2.38-2.29v-2.62h-1v-1.43h1v-1.56h1.85v1.56h1.59v1.43h-1.59v2.59a.75.75,0,0,0,.79.85,1.27,1.27,0,0,0,.75-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,306.68a3.52,3.52,0,1,1,3.51,3.29A3.29,3.29,0,0,1,188,306.68Zm5.14,0a1.64,1.64,0,1,0-1.63,1.77A1.62,1.62,0,0,0,193.12,306.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.59,301.07h1.85v8.8h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,301.56a1.06,1.06,0,0,1,1.15-1,1,1,0,0,1,1.15,1,1.15,1.15,0,0,1-2.3,0Zm.23,1.93H205v6.38h-1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,309.28l.62-1.33a4.36,4.36,0,0,0,2.22.62c.86,0,1.18-.23,1.18-.58,0-1.05-3.86,0-3.86-2.53,0-1.21,1.09-2.07,2.95-2.07a5.2,5.2,0,0,1,2.46.56l-.62,1.32a3.62,3.62,0,0,0-1.84-.48c-.83,0-1.18.27-1.18.6,0,1.09,3.85,0,3.85,2.55,0,1.19-1.1,2-3,2A5.54,5.54,0,0,1,206.12,309.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.17,309.57a2.68,2.68,0,0,1-1.51.4,2.11,2.11,0,0,1-2.39-2.29v-2.62h-1v-1.43h1v-1.56h1.85v1.56h1.59v1.43h-1.59v2.59a.75.75,0,0,0,.8.85,1.31,1.31,0,0,0,.75-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,307.2H219.4a1.7,1.7,0,0,0,1.83,1.29,2.19,2.19,0,0,0,1.6-.62l1,1.07a3.35,3.35,0,0,1-2.63,1c-2.21,0-3.65-1.39-3.65-3.29a3.25,3.25,0,0,1,3.41-3.29,3.16,3.16,0,0,1,3.33,3.31C224.27,306.85,224.24,307.05,224.23,307.2Zm-4.86-1.08h3.15a1.6,1.6,0,0,0-3.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,306.22v3.65h-1.85V306.5c0-1-.48-1.5-1.29-1.5s-1.54.54-1.54,1.72v3.15H225.5v-6.38h1.77v.75a2.79,2.79,0,0,1,2.11-.85A2.51,2.51,0,0,1,232,306.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,407.9a3.34,3.34,0,0,1,3.5-3.38,3.27,3.27,0,0,1,2.51,1l-.62.6a2.44,2.44,0,0,0-1.85-.79,2.54,2.54,0,1,0,0,5.08,2.45,2.45,0,0,0,1.85-.8l.62.6a3.28,3.28,0,0,1-2.52,1A3.34,3.34,0,0,1,171.47,407.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,408.18v3h-.86v-.66a1.86,1.86,0,0,1-1.64.72c-1.13,0-1.85-.61-1.85-1.47s.52-1.47,2-1.47h1.43v-.18c0-.76-.44-1.2-1.34-1.2a2.53,2.53,0,0,0-1.58.54l-.38-.68a3.32,3.32,0,0,1,2.07-.64C181.81,406.16,182.59,406.82,182.59,408.18Zm-.91,1.49V409h-1.39c-.9,0-1.15.35-1.15.78s.41.81,1.1.81A1.44,1.44,0,0,0,181.68,409.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,408.32v2.88h-.91v-2.77c0-1-.49-1.46-1.34-1.46a1.48,1.48,0,0,0-1.59,1.66v2.57h-.9v-5h.86V407a2.15,2.15,0,0,1,1.81-.8A1.93,1.93,0,0,1,189,408.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,408.7a2.5,2.5,0,0,1,2.65-2.54,2.21,2.21,0,0,1,2,1.06l-.69.44a1.55,1.55,0,0,0-1.35-.71,1.76,1.76,0,0,0,0,3.52,1.56,1.56,0,0,0,1.35-.72l.69.43a2.22,2.22,0,0,1-2,1.08A2.51,2.51,0,0,1,190.25,408.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52,409h-4.05a1.69,1.69,0,0,0,1.81,1.47,1.86,1.86,0,0,0,1.44-.61l.5.59a2.73,2.73,0,0,1-4.66-1.75,2.45,2.45,0,0,1,2.51-2.54,2.41,2.41,0,0,1,2.47,2.57A2.45,2.45,0,0,1,200.52,409Zm-4.05-.65h3.2a1.61,1.61,0,0,0-3.2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8,404.2h.9v7h-.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.91,424.83s.25,0,.73-.07l.89-.06,1.23-.2A15.19,15.19,0,0,0,248,409.35a34.69,34.69,0,0,0-.13-3.92,15.8,15.8,0,0,0-1.06-4,16.61,16.61,0,0,0-2.27-3.75,16.36,16.36,0,0,0-3.45-3.05,15.77,15.77,0,0,0-9.46-2.39l-10.89,0-24,0-55,0A15.17,15.17,0,0,0,134.8,394a14.85,14.85,0,0,0-5.27,4.58,14.51,14.51,0,0,0-2.6,6.38,11,11,0,0,0-.16,1.71c0,.57,0,1.16,0,1.74a20.24,20.24,0,0,0,.18,3.41,14.84,14.84,0,0,0,2.4,6.22,15.32,15.32,0,0,0,4.78,4.47,14.87,14.87,0,0,0,6.09,2l1.59.07h4.8l44.93.05,30.29.08,8.24,0,2.14,0,.73,0-.73,0-2.14,0-8.24.05-30.29.08-44.93.05h-4.8l-1.64-.08a15.32,15.32,0,0,1-6.29-2.06,15.89,15.89,0,0,1-4.95-4.61,15.52,15.52,0,0,1-2.49-6.43,21.49,21.49,0,0,1-.18-3.49c0-.59,0-1.16,0-1.76a10.59,10.59,0,0,1,.16-1.77,15.15,15.15,0,0,1,2.68-6.6,15.54,15.54,0,0,1,5.46-4.75,15.79,15.79,0,0,1,7.12-1.74l55,0,24,0,10.89,0a15.68,15.68,0,0,1,13.18,5.62,15.17,15.17,0,0,1,3.37,7.93,38.15,38.15,0,0,1,.11,4A15.35,15.35,0,0,1,243.12,421a15.11,15.11,0,0,1-7.34,3.6l-1.24.17c-.35,0-.66,0-.9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83,100.53a52.68,52.68,0,0,1-7.73.28,52.76,52.76,0,0,1-7.74-.28,54.49,54.49,0,0,1,7.74-.28A54.4,54.4,0,0,1,264.83,100.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83,96.49a52.68,52.68,0,0,1-7.73.28,52.76,52.76,0,0,1-7.74-.28,54.49,54.49,0,0,1,7.74-.28A54.4,54.4,0,0,1,264.83,96.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83,92.45a52.68,52.68,0,0,1-7.73.28,52.76,52.76,0,0,1-7.74-.28,54.49,54.49,0,0,1,7.74-.28A54.4,54.4,0,0,1,264.83,92.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.67,103.14a1.32,1.32,0,0,1,.33,0l.93,0,3.41-.08-.09.1c0-.76,0-1.58,0-2.48,0-.46,0-.89,0-1.42a1.31,1.31,0,0,1,1.15-1c.55,0,1,0,1.63,0a1.33,1.33,0,0,1,1.12,1.32c0,1.15,0,2.36,0,3.61l-.16-.16,4.31,0-.17.16c0-1.73,0-3.52,0-5.36,0-.46,0-.92,0-1.37a1.39,1.39,0,0,0-.6-1l-1.88-1.85-1.82-1.79-.88-.87c-.3-.29-.54-.6-.89-.67a1.16,1.16,0,0,0-1,.19c-.26.22-.54.53-.8.79-.53.53-1,1-1.54,1.56-1,1-2,1.93-2.73,2.8a3,3,0,0,0-.21,1.61c0,.53,0,1,0,1.52,0,.93,0,1.74,0,2.44s0,1.14,0,1.56a3.85,3.85,0,0,1,0,.57,3.2,3.2,0,0,1,0-.52c0-.42,0-.92,0-1.54s0-1.53-.06-2.46c0-.49,0-1,0-1.55,0-.28,0-.56,0-.85a1.84,1.84,0,0,1,.24-.9c.8-1,1.75-1.84,2.73-2.88L115,90.87c.28-.27.5-.54.83-.82a1.46,1.46,0,0,1,1.25-.25,2.27,2.27,0,0,1,1,.74l.89.87,1.82,1.78,1.88,1.86a3.08,3.08,0,0,1,.49.52,1.39,1.39,0,0,1,.22.72c0,.46,0,.91,0,1.38,0,1.83,0,3.63,0,5.36v.17h-.17l-4.31,0h-.15v-.16c0-1.25,0-2.46,0-3.61a1,1,0,0,0-.87-1c-.5,0-1.08,0-1.57,0a1.05,1.05,0,0,0-.92.84c0,.43,0,.93,0,1.37v2.57h-.1l-3.47,0-.9,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.48,159.25c.14,4.69-3.18,5.14-5.47,5.33s-4.91-.85-7-1.84c-4.24-2-8.35-4.08-10.06-8.76",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5,115.48c.14,0,.26,7,.26,15.55s-.12,15.54-.26,15.54-.26-7-.26-15.54S433.36,115.48,433.5,115.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.55,118.9c.14,0,.26,5.31.26,11.87s-.12,11.86-.26,11.86-.26-5.31-.26-11.86S437.41,118.9,437.55,118.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.11,122.29a72.13,72.13,0,0,1,.26,8.59,72.24,72.24,0,0,1-.26,8.6,69.79,69.79,0,0,1-.26-8.6A69.68,69.68,0,0,1,442.11,122.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,125.21a21.9,21.9,0,0,1,.26,4.8,21.85,21.85,0,0,1-.26,4.79,22.61,22.61,0,0,1-.26-4.79A22.67,22.67,0,0,1,446.08,125.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.59,127.55a13.43,13.43,0,0,1,0,5.26,13.43,13.43,0,0,1,0-5.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.57,124.74a22.67,22.67,0,0,1,.26,4.8,22.53,22.53,0,0,1-.26,4.79,21.77,21.77,0,0,1-.26-4.79A21.9,21.9,0,0,1,453.57,124.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.31,120.89a79.11,79.11,0,0,1,.26,9,79.11,79.11,0,0,1-.26,9,76.42,76.42,0,0,1-.26-9A76.42,76.42,0,0,1,457.31,120.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.87,122.29a72.13,72.13,0,0,1,.26,8.59,72.24,72.24,0,0,1-.26,8.6,69.79,69.79,0,0,1-.26-8.6A69.68,69.68,0,0,1,409.87,122.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.84,125.21a21.9,21.9,0,0,1,.26,4.8,21.85,21.85,0,0,1-.26,4.79,22.61,22.61,0,0,1-.26-4.79A22.67,22.67,0,0,1,413.84,125.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.35,127.55a13.43,13.43,0,0,1,0,5.26,6.74,6.74,0,0,1-.26-2.63A6.74,6.74,0,0,1,417.35,127.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.32,123.34a36.42,36.42,0,0,1,.26,6.2,36.25,36.25,0,0,1-.26,6.19,37.52,37.52,0,0,1-.26-6.19A37.7,37.7,0,0,1,421.32,123.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.06,120.89a75,75,0,0,1,.27,9,75,75,0,0,1-.27,9,79.11,79.11,0,0,1-.26-9A79.11,79.11,0,0,1,425.06,120.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.62,119c.15,0,.26,5.13.26,11.45s-.11,11.46-.26,11.46-.26-5.13-.26-11.46S429.48,119,429.62,119Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,134.33a21.77,21.77,0,0,1-.26-4.79,21.9,21.9,0,0,1,.26-4.8,22.67,22.67,0,0,1,.26,4.8A22.53,22.53,0,0,1,405.62,134.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,132a13.43,13.43,0,0,1,0-5.26,13.43,13.43,0,0,1,0,5.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,124.74a22.67,22.67,0,0,1,.26,4.8,22.53,22.53,0,0,1-.26,4.79,21.77,21.77,0,0,1-.26-4.79A21.9,21.9,0,0,1,461,124.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.48,127.08a13.43,13.43,0,0,1,0,5.26,6.7,6.7,0,0,1-.26-2.63A6.74,6.74,0,0,1,464.48,127.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.21,431.07l7.29,21.14s23.94-.3,25.66,3.48l-40.48,15.59L409,438.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.3,455.28a1.77,1.77,0,0,0-.41,2.33,1.7,1.7,0,0,0,2.3.43,1.88,1.88,0,0,0,.43-2.47,1.77,1.77,0,0,0-2.45-.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.68,471.28,420.52,468l39.25-13.71s2.11.09,2.39,1.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.08,451.75c.07.2-.89.67-1.62,1.68s-.92,2.05-1.13,2-.36-1.27.54-2.47S437.05,451.56,437.08,451.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,451.87c.12.18-.61.84-1,1.94s-.2,2.05-.4,2.12-.76-1-.3-2.36S441.92,451.69,442,451.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.37,456c-.16.11-.82-.77-.73-2s.85-2.07,1-1.93-.21.93-.26,2S446.56,455.93,446.37,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,447.12c0,.21-1,.29-2.11.79s-1.83,1.2-2,1.07.39-1.16,1.68-1.74S434.92,446.93,434.88,447.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18,423.45l-.46.6L266,435.49l-10.85,7.44,14.53,28,16,0s-1.16-3.85-8.85-5.84l-.51-15.37,13.82-15.18",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "255.11 442.93 269.64 470.92 285.64 470.94 283.84 468.53 270.83 467.8 257.42 441.34 255.11 442.93",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.69,458.06c-.12.16-1-.36-2.28-.33s-2.15.55-2.27.39.75-1.08,2.26-1.09S276.84,457.93,276.69,458.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.43,454.25c-.16.11-.87-.83-2.15-1.08s-2.29.33-2.39.16.13-.34.58-.58a3,3,0,0,1,3.65.73C276.44,453.88,276.51,454.2,276.43,454.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,449.35c-.18.09-.72-.83-1.83-1.22s-2.12,0-2.2-.2.16-.31.6-.47a2.72,2.72,0,0,1,1.83,0,2.8,2.8,0,0,1,1.43,1.14C276.61,449,276.62,449.32,276.54,449.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.82,445.56c-.19.07-.63-.84-1.63-1.49s-2-.74-2-.94,1.19-.45,2.39.36S281,445.54,280.82,445.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.87,442.45a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,267.87,442.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,296.19c3.78,1.4-14.33,75.91-14.33,75.91L290.1,437.83l-18.22-15.7,40.89-62.89L325.6,257.9l29.48,1.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21,257.9c.52,1.44,30.9,106.1,30.9,106.1L432,435.37l-22,7.17s-28.86-66.79-32.33-78S366,337,366,337L350,294.7s-25.58-14.13-23.7-38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.59 440.48 433.29 431.89 406.81 440.49 409.89 449.57 434.59 440.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.51,257.9s.05.28.12.84l.31,2.46a66.19,66.19,0,0,0,1.75,9.26,30,30,0,0,0,2.49,6.23,31.11,31.11,0,0,0,4.64,6.39,53.16,53.16,0,0,0,15.42,11.06l.09.05,0,.09c1,3.8,2.31,7.73,3.74,11.79s3,8.25,4.62,12.57c3.26,8.63,6.86,17.75,10.59,27.18,5.2,13,10,25.49,14.67,36.73s8.92,21.31,12.52,29.77,6.53,15.3,8.47,20.06c1,2.38,1.71,4.24,2.19,5.5l.54,1.45c.12.32.17.49.17.49s-.08-.16-.22-.48l-.58-1.42-2.28-5.46c-2-4.74-5-11.57-8.63-20s-8-18.5-12.63-29.74S375,359,369.81,346c-3.73-9.43-7.32-18.55-10.57-27.2-1.63-4.31-3.17-8.52-4.59-12.59s-2.73-8-3.72-11.83l.11.14a53.23,53.23,0,0,1-15.48-11.21,31.69,31.69,0,0,1-4.66-6.48,30.46,30.46,0,0,1-2.45-6.31,62.36,62.36,0,0,1-1.64-9.31c-.11-1.07-.19-1.89-.25-2.47S326.51,257.9,326.51,257.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.37,299.21a2.28,2.28,0,0,1-.75.43,6.94,6.94,0,0,1-2.27.53,10.3,10.3,0,0,1-7.16-2.51,17,17,0,0,1-4.37-6.26c-.38-.9-.64-1.65-.81-2.17a2.32,2.32,0,0,1-.19-.83c.08,0,.5,1.1,1.34,2.84a18.37,18.37,0,0,0,4.37,6,10.45,10.45,0,0,0,6.8,2.54A12.09,12.09,0,0,0,371.37,299.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.93,363a39.45,39.45,0,0,0-6.11-2.88,40,40,0,0,0-6.63-1.28,5.7,5.7,0,0,1,2-.11,18.49,18.49,0,0,1,9.17,3A5.77,5.77,0,0,1,325.93,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,432c0,.13-5.78,2.2-13,4.62s-13.11,4.27-13.16,4.13,5.77-2.21,13-4.62S433,431.84,433,432Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.29 428.25 271.16 419.68 292.6 437.84 286.01 445.03 266.29 428.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,437.84a4.23,4.23,0,0,1-.88-.68l-2.27-2c-1.91-1.68-4.55-4-7.58-6.4s-5.7-4.7-7.64-6.35c-1-.82-1.75-1.5-2.28-2s-.82-.75-.79-.78a5.54,5.54,0,0,1,.92.62c.57.43,1.38,1.06,2.38,1.84,2,1.58,4.74,3.78,7.74,6.24s5.65,4.78,7.5,6.53c.93.87,1.66,1.59,2.16,2.1A4.67,4.67,0,0,1,292.6,437.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,98c.92-3.42,3.49-5.1,6.83-6.24a11,11,0,0,1,10.06,1.64c1.88,1.43,3.35,3.51,5.58,4.28,3.68,1.28,8-1.47,11.52.18a5,5,0,0,1-2.38,9.56c2.4.88,3.14,4.3,1.74,6.44s-4.28,2.94-6.79,2.47a14.09,14.09,0,0,1-6.6-3.7c-1.9-1.7-3.6-3.64-5.63-5.19a11,11,0,0,0-7.05-2.59c-3.45.19-6.41,2.79-7.95,5.89s-1.9,6.64-2.09,10.09-.25,7-1.28,10.27c-.12.39-.3.82-.69.94-.56.17-1-.42-1.31-.94a50.57,50.57,0,0,1-5.8-18.87c-.39-3.83-.29-7.45,1.81-10.67s7.42-5.6,10-3.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.34,114l-1.76,38.74c-.31,6.59.6,16.33,11,16.33h0c9.05-.68,11.73-9.14,12-15.29.13-2.92.25-5.35.28-5.65,0,0,9.91-.48,11.06-10.21.56-4.7.93-14.47,1.15-23.32A18.24,18.24,0,0,0,382.8,96l-.94-.1C371.66,95.39,365.55,103.78,365.34,114Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.93,148a22.72,22.72,0,0,1-12.31-5s2.25,7.33,12.07,7.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,120.8a1.4,1.4,0,0,1-1.49,1.26,1.34,1.34,0,0,1-1.3-1.41,1.4,1.4,0,0,1,1.49-1.26A1.34,1.34,0,0,1,395.58,120.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.51,119.13c-.19.17-1.16-.73-2.66-.88s-2.67.48-2.82.28.14-.4.66-.7a3.85,3.85,0,0,1,2.28-.45,3.77,3.77,0,0,1,2.09.93C396.48,118.72,396.61,119.06,396.51,119.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,119.74a1.4,1.4,0,0,1-1.49,1.27,1.35,1.35,0,0,1-1.3-1.41,1.4,1.4,0,0,1,1.49-1.26A1.33,1.33,0,0,1,380.84,119.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.77,117.85c-.2.16-1.17-.73-2.66-.89s-2.68.48-2.82.28.14-.4.65-.7a3.85,3.85,0,0,1,2.28-.44,3.7,3.7,0,0,1,2.1.93C381.74,117.43,381.86,117.77,381.77,117.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,129.53a9.58,9.58,0,0,1,2.48-.18c.38,0,.75,0,.84-.29a1.92,1.92,0,0,0-.13-1.16c-.26-1-.53-2-.82-3-1.13-4.32-1.9-7.84-1.73-7.89s1.23,3.42,2.36,7.73c.27,1.06.53,2.07.77,3a2.19,2.19,0,0,1,0,1.52,1,1,0,0,1-.69.5,3,3,0,0,1-.66,0A10,10,0,0,1,386,129.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.78,112c-.19.39-1.67,0-3.45.07s-3.25.35-3.44,0c-.09-.19.2-.54.82-.88a5.69,5.69,0,0,1,2.62-.61,5.61,5.61,0,0,1,2.62.59C382.57,111.48,382.86,111.83,382.78,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.42,114.74c-.3.31-1.29-.15-2.53-.3s-2.31,0-2.52-.39c-.09-.19.12-.51.61-.78a3.45,3.45,0,0,1,2.12-.34,3.52,3.52,0,0,1,1.95.9C396.45,114.22,396.56,114.59,396.42,114.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.37,121.28c-.16-.09-6.48-2.69-7,4s6.32,5.8,6.34,5.61S365.37,121.28,365.37,121.28Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.88,128.2s-.12.07-.33.15a1.17,1.17,0,0,1-.87,0,2.86,2.86,0,0,1-1.14-2.68A3.87,3.87,0,0,1,361,124a1.32,1.32,0,0,1,.94-.83.59.59,0,0,1,.67.37c.07.19,0,.32,0,.34s.15-.11.12-.39a.73.73,0,0,0-.23-.43.84.84,0,0,0-.63-.22,1.62,1.62,0,0,0-1.29.94,4,4,0,0,0-.55,1.84,3,3,0,0,0,1.49,3,1.26,1.26,0,0,0,1.08-.1C362.85,128.36,362.9,128.21,362.88,128.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,112.77a14.14,14.14,0,0,1-12.2-4.14c-2.15-2.27-3.67-5.35-6.55-6.58a7.94,7.94,0,0,0-6.14.19,15.29,15.29,0,0,0-5,3.72c1.35,5.15-.5,10.55-2.33,15.55a2.64,2.64,0,0,1-.94,1.45c-.85.52-2-.07-2.59-.87a8.17,8.17,0,0,1-1.34-4.53,27.59,27.59,0,0,1,1.21-10.8,18.77,18.77,0,0,1,6.13-8.87,17.78,17.78,0,0,1,12.89-3.36,21.81,21.81,0,0,1,12.11,5.84,12.83,12.83,0,0,1,3.59,5.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.48,133.76a6.57,6.57,0,0,1-.86,1.69,2.25,2.25,0,0,1-1.6.93,2,2,0,0,1-1.7-.93,3.23,3.23,0,0,1-.48-1.94c0-.61.31-1.34.92-1.41a1.5,1.5,0,0,1,.74.16l3.19,1.29",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,136.38a4.52,4.52,0,0,1-1.71-.21,2.42,2.42,0,0,1-1.28-1.16,2.53,2.53,0,0,1,0-2.09,2.22,2.22,0,0,1,.27-.48c.13-.13.11-.13.24-.11l.52.2.52.22c.68.27,1.3.52,1.82.71a5.53,5.53,0,0,0,1.74.52,6,6,0,0,0-1.58-.89c-.5-.24-1.1-.52-1.77-.82l-.52-.24c-.19-.07-.33-.16-.58-.24a.8.8,0,0,0-.48,0,.85.85,0,0,0-.35.28,2.81,2.81,0,0,0-.36.6,3,3,0,0,0,.1,2.55,2.65,2.65,0,0,0,1.62,1.31,2.55,2.55,0,0,0,1.38.06C385.07,136.52,385.22,136.42,385.21,136.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,187.48,399.56,227a12.09,12.09,0,0,1-9.42,6.87h0a12.1,12.1,0,0,1-12.62-7.15l-13.8-31.61,24-28.25,2.34,33.93,15.17-21.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.66,214.12a50.34,50.34,0,0,1,2.39-7,52.8,52.8,0,0,1,2.87-6.77,50.34,50.34,0,0,1-2.39,6.95A52.8,52.8,0,0,1,384.66,214.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.21,257.9l4.32-4.81a8.06,8.06,0,0,0,2.05-6.13l-2.29-5.8,3.06-68.85c.31-5.58.24-13.62-5-15.88l-22.65-6.7s-15.44,3.29-19.09,11.36c-2.87,6.33-7.34,49.13-7.34,49.13l-6.5,17.37c-.75,3.42-5.71,22.58-6,27l.86,3.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.29,241.16s0-.12,0-.36,0-.62,0-1c0-1,0-2.29,0-3.92,0-3.41.07-8.15.11-13.71h0c.32-3.88.59-8.2.85-12.75.49-8.77.87-16.71,1.28-22.46.2-2.87.4-5.19.55-6.79.09-.76.15-1.37.2-1.85a3.39,3.39,0,0,1,.11-.64,2.74,2.74,0,0,1,0,.65c0,.48-.06,1.09-.1,1.85-.1,1.67-.23,4-.39,6.81-.29,5.8-.69,13.72-1.13,22.46-.26,4.55-.55,8.88-.9,12.77v0c-.12,5.56-.22,10.29-.3,13.71-.05,1.63-.1,2.94-.13,3.91,0,.41,0,.75-.05,1A2,2,0,0,1,388.29,241.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.36,271.54l20.46-7.1-17.73-47.69,12.13-41.38c1.85-7.14-1.38-17.18-8.52-19-.31-.08-.87-2.64-1.18-2.51-2.81,1.15-9.82,5.9-12.72,10.59a38.76,38.76,0,0,0-4.72,11.69l-7.36,31.64a30.94,30.94,0,0,0,1.43,18.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,223a.7.7,0,0,1,.11.22l.29.68,1.07,2.64,4,9.95,13.76,34.94-.31-.14,20.75-7.12.14.5a1.74,1.74,0,0,1-.52-.7l-.21-.55c-.14-.36-.28-.73-.43-1.1-.28-.74-.56-1.49-.85-2.24-.58-1.51-1.16-3.05-1.75-4.6-5.31-14.14-10.3-27.4-14.54-38.68l0-.06v-.07c2.85-12.35,5.23-22.66,6.91-29.92.84-3.59,1.51-6.42,2-8.38.23-.95.41-1.68.54-2.2.06-.24.11-.42.14-.57l.06-.19a.6.6,0,0,1,0,.2c0,.15-.07.33-.11.57-.12.53-.27,1.27-.47,2.22-.44,2-1.06,4.81-1.85,8.41l-6.73,30v-.13c4.25,11.27,9.26,24.52,14.6,38.66l1.74,4.59.86,2.25.42,1.1.21.54a.12.12,0,0,1,0,.14.23.23,0,0,0,0,.1l0,.07v.05h0l.05.24.09.26L347,271.76l-.22.08-.08-.22-13.58-35-3.84-10-1-2.66c-.1-.29-.18-.52-.25-.69S328,223,328,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.85,218.14a4.25,4.25,0,0,1,1.39-1,11.81,11.81,0,0,1,3.92-1.25,11.66,11.66,0,0,1,4.11.16,3.9,3.9,0,0,1,1.6.58,22,22,0,0,0-5.64-.23A22.45,22.45,0,0,0,338.85,218.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M393.55,195.91,395.23,232c-1.77,1.34-4.22,1.87-7,2,.05-1.13,1.91-33.17,1.91-33.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,166.86a2,2,0,0,1-.39.25,11.2,11.2,0,0,1-1.19.61,20.85,20.85,0,0,1-4.7,1.47A34.26,34.26,0,0,1,369,168.12a33.87,33.87,0,0,1-13.86-8.24,31,31,0,0,1-3.23-3.71c-.35-.46-.59-.85-.76-1.1a2.19,2.19,0,0,1-.23-.41A15.86,15.86,0,0,1,352,156a35.93,35.93,0,0,0,3.32,3.57,34.82,34.82,0,0,0,13.76,8A35.39,35.39,0,0,0,385,168.83a22.82,22.82,0,0,0,4.69-1.3A17.71,17.71,0,0,1,391.33,166.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.17,186.7a3.21,3.21,0,0,1-1,0,23.21,23.21,0,0,1-2.66-.38,28.59,28.59,0,0,1-8.28-3.09,29.73,29.73,0,0,1-6.93-5.48,26.41,26.41,0,0,1-1.74-2,3.85,3.85,0,0,1-.54-.82c.07-.06.95,1,2.54,2.6a33.59,33.59,0,0,0,6.93,5.29,31.88,31.88,0,0,0,8.1,3.18C354.79,186.46,356.18,186.61,356.17,186.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,195.91a6.84,6.84,0,0,1-1.28.49,28.62,28.62,0,0,1-3.62,1,37.2,37.2,0,0,1-5.51.78,43.72,43.72,0,0,1-6.82-.11,47,47,0,0,1-12-3c-1.47-.58-2.65-1.1-3.43-1.5a7.13,7.13,0,0,1-1.21-.66,7.55,7.55,0,0,1,1.29.47c.81.35,2,.81,3.48,1.34a51.69,51.69,0,0,0,11.92,2.79,46.84,46.84,0,0,0,6.73.16,45.17,45.17,0,0,0,5.47-.67C387.46,196.44,389.31,195.81,389.34,195.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,223.17a8.14,8.14,0,0,1-1.4.61,17.1,17.1,0,0,1-1.7.59c-.67.2-1.42.47-2.29.66s-1.79.43-2.82.59-2.13.31-3.29.44a45,45,0,0,1-7.6,0,44,44,0,0,1-7.46-1.45c-1.12-.35-2.18-.67-3.14-1.06s-1.86-.76-2.66-1.13-1.5-.76-2.13-1.08-1.13-.64-1.55-.91a9,9,0,0,1-1.26-.86,7.81,7.81,0,0,1,1.37.69c.42.24.95.53,1.58.82s1.32.68,2.14,1,1.68.73,2.66,1.06,2,.68,3.12,1A46.78,46.78,0,0,0,369,225.5a46.3,46.3,0,0,0,7.51.08c1.15-.12,2.24-.2,3.26-.39s1.95-.33,2.81-.52,1.62-.4,2.29-.58,1.25-.35,1.71-.5A7.37,7.37,0,0,1,388,223.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,218.85a9.44,9.44,0,0,1-2.67-.64,25,25,0,0,1-10.9-7.36,9.89,9.89,0,0,1-1.59-2.23,24.51,24.51,0,0,1,1.87,2A29.42,29.42,0,0,0,402,217.86C403.51,218.48,404.52,218.77,404.5,218.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,197.93a8.28,8.28,0,0,1-2.36-.69,24,24,0,0,1-5.23-2.83,24.51,24.51,0,0,1-4.4-4,8.57,8.57,0,0,1-1.43-2,47.86,47.86,0,0,0,6.13,5.59A47.1,47.1,0,0,0,413,197.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.36,211a3,3,0,0,1-.9.2,20.41,20.41,0,0,1-2.5.22,28.77,28.77,0,0,1-15.86-4.17,20.31,20.31,0,0,1-2.07-1.43c-.46-.37-.71-.58-.69-.61s1.11.7,3,1.72A32.53,32.53,0,0,0,347,211.05C349.05,211.06,350.35,210.91,350.36,211Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.59,226.35c0,.09-1.22.07-3.15.3a27,27,0,0,0-13.82,5.82c-1.52,1.22-2.35,2.11-2.41,2.05s.15-.27.51-.68a16,16,0,0,1,1.66-1.65,24.17,24.17,0,0,1,14-5.91,17.48,17.48,0,0,1,2.34,0A2.7,2.7,0,0,1,352.59,226.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.38,253.14c0,.1-1.28-.12-3.33-.1a23.76,23.76,0,0,0-3.57.33,23.07,23.07,0,0,0-8.17,3.06,22.54,22.54,0,0,0-2.91,2.09c-1.56,1.33-2.37,2.32-2.45,2.26a3.18,3.18,0,0,1,.52-.74,15.42,15.42,0,0,1,1.68-1.79,20.8,20.8,0,0,1,2.9-2.23,23.91,23.91,0,0,1,4-2,22.6,22.6,0,0,1,4.34-1.12,19.31,19.31,0,0,1,3.65-.22,14.65,14.65,0,0,1,2.45.24A3.19,3.19,0,0,1,363.38,253.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.66,245.92a48.94,48.94,0,0,1-9.94-1.21,23.73,23.73,0,0,1,5,.34A24.61,24.61,0,0,1,336.66,245.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.63,232.36A51.17,51.17,0,0,0,332,246.05c1,3.28-2.45,8.46,1.61,11.85h8c-3.89-9.57-7.6-19.61-11.18-28.62"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M387,241.87a3.65,3.65,0,0,1-.6.68,16.51,16.51,0,0,1-1.87,1.6,21.13,21.13,0,0,1-3.13,1.9,23.7,23.7,0,0,1-4.2,1.57,24,24,0,0,1-4.44.68,20,20,0,0,1-3.66-.14,15,15,0,0,1-2.41-.47,2.89,2.89,0,0,1-.85-.31c0-.09,1.26.24,3.3.42a23.55,23.55,0,0,0,3.59,0,25.85,25.85,0,0,0,4.34-.7,27.48,27.48,0,0,0,4.12-1.5,22.77,22.77,0,0,0,3.12-1.78C386,242.69,386.9,241.8,387,241.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.39,247.54a6.69,6.69,0,0,1-1.92.94,19,19,0,0,1-5.05,1.08,21.83,21.83,0,0,1-5.15-.24,7.17,7.17,0,0,1-2.07-.51c0-.18,3.23.51,7.18.23A36.85,36.85,0,0,0,376.39,247.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.4,169.65l9.8-.71s2.14,2.72.43,4.84-5,7.69-5,7.69L420,182.55l-3.06,5.53-11.58-7.5,5.26-10.48,8.51-7.45,5.41.11,3,3.63s-3.34,1.64-4.94-1l-2.59.51,0,1.5A2.23,2.23,0,0,0,422.4,169.65Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.08,169.31l6.67-1.92a2.56,2.56,0,0,1,2.23.85l.2.69L433,172.47Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.51,176.64a6.67,6.67,0,0,1,.9-1.45,8.79,8.79,0,0,0,1.59-3.63,4.48,4.48,0,0,0-.19-2.12,6,6,0,0,1-.26-1,2.73,2.73,0,0,1,0-.92,4.71,4.71,0,0,1,.5-1.65,7.62,7.62,0,0,1-.13,1.7,3.06,3.06,0,0,0,.31,1.7,4.78,4.78,0,0,1,.25,2.35,8,8,0,0,1-1.81,3.78C418,176.23,417.56,176.68,417.51,176.64Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.73,161.33c0,.19,1,2.31,1,2.31L418.6,177.11l-1.36-2.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.6,181a1.57,1.57,0,0,0-.09-2.25,4.47,4.47,0,0,0-2.32-1,18.09,18.09,0,0,0-4.14-.49,2.81,2.81,0,0,0-1.32.3,1.16,1.16,0,0,0-.61,1.14c.11.55.69.85,1.21,1.05a19.81,19.81,0,0,0,4.36,1.12",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.69,180.93a8.27,8.27,0,0,1-2.66-.36c-.4-.1-.84-.23-1.3-.38a4.08,4.08,0,0,1-1.47-.72,1.22,1.22,0,0,1-.4-.93,1.41,1.41,0,0,1,.46-.93,2.71,2.71,0,0,1,1.89-.55,16.24,16.24,0,0,1,3.56.42,5.66,5.66,0,0,1,2.76,1.07,1.84,1.84,0,0,1,.55,1.92c-.18.48-.48.58-.48.56s.19-.19.29-.61a1.71,1.71,0,0,0-.6-1.6,5.73,5.73,0,0,0-2.61-.87,18,18,0,0,0-3.46-.37,2.28,2.28,0,0,0-1.55.4.73.73,0,0,0-.07,1.14,3.75,3.75,0,0,0,1.27.66c.45.17.87.31,1.26.43C423.69,180.69,424.7,180.84,424.69,180.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.94,175.71c-2.14-.94-3.7-1.44-5.84-2.37a3.56,3.56,0,0,0-2.19-.45c-.75.17-1.35,1.07-.94,1.71a1.93,1.93,0,0,0,.62.51l6.22,3.78",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,178.89a14.23,14.23,0,0,1-2.46-1.28l-2.6-1.51-1.54-.92a1.33,1.33,0,0,1-.63-.94,1.47,1.47,0,0,1,.4-1.07,1.65,1.65,0,0,1,1-.55,2.59,2.59,0,0,1,1,0,10.64,10.64,0,0,1,1.69.66l2.77,1.17a11.35,11.35,0,0,1,2.49,1.22,19.17,19.17,0,0,1-2.63-.88c-.8-.29-1.77-.63-2.82-1.07a10.51,10.51,0,0,0-1.62-.6,1.45,1.45,0,0,0-1.5.35,1,1,0,0,0-.27.69.77.77,0,0,0,.4.56l1.5.93,2.54,1.61A14.77,14.77,0,0,1,428.81,178.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,172.47l-5.86-2.15a3.6,3.6,0,0,0-2.22-.3c-.73.21-1.28,1.15-.83,1.76a1.84,1.84,0,0,0,.65.48l6.45,3.37",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.18,175.63a15.1,15.1,0,0,1-2.53-1.12L426,173.17l-1.59-.81a1.29,1.29,0,0,1-.7-.87,1.44,1.44,0,0,1,.3-1.11,1.65,1.65,0,0,1,.92-.63,2.57,2.57,0,0,1,1,0,8.59,8.59,0,0,1,1.73.54l2.8,1.08a13.52,13.52,0,0,1,2.53,1.13,16.1,16.1,0,0,1-2.66-.78l-2.83-1a9.48,9.48,0,0,0-1.65-.49,1.44,1.44,0,0,0-1.46.47c-.86,1.09.94,1.49,1.8,2.06l2.63,1.44A14.37,14.37,0,0,1,431.18,175.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.57,162c-.06,0,.11-.59.68-1.35a6.64,6.64,0,0,1,2.94-2.15,6.54,6.54,0,0,1,3.64-.26c.92.21,1.42.53,1.39.59s-.56-.12-1.45-.22a7.35,7.35,0,0,0-3.4.38,7.52,7.52,0,0,0-2.84,1.9C432.93,161.54,432.64,162,432.57,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.25,160.77a4.5,4.5,0,0,1,1.12-1.93,9.25,9.25,0,0,1,4.57-2.84,11.19,11.19,0,0,1,5.39-.08,6,6,0,0,1,2.09.77c0,.08-.83-.19-2.16-.4a12.41,12.41,0,0,0-5.18.21,9.85,9.85,0,0,0-4.44,2.59C430.71,160.05,430.33,160.82,430.25,160.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,159.67s.1-.28.39-.71a11.75,11.75,0,0,1,1.39-1.69,14.65,14.65,0,0,1,6.14-3.77,14.8,14.8,0,0,1,7.19-.36,11.69,11.69,0,0,1,2.1.62,2.22,2.22,0,0,1,.72.36c0,.09-1.09-.34-2.88-.62a15.43,15.43,0,0,0-13,4C427.6,158.77,427,159.72,426.89,159.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,158.54a3.25,3.25,0,0,1,.32-.95,9.3,9.3,0,0,1,1.48-2.29,13.53,13.53,0,0,1,3.08-2.62,21.58,21.58,0,0,1,4.48-2.11,16.76,16.76,0,0,1,8.9-.58,15.77,15.77,0,0,1,2.61.75,3,3,0,0,1,.9.42c0,.09-1.35-.44-3.58-.81a17.58,17.58,0,0,0-8.66.71,18.17,18.17,0,0,0-7.46,4.48A17.08,17.08,0,0,0,424.51,158.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.79,273.24c-2-.72-1.83.69-1.1,2.35-3.88,2.45-8.12,5.5-12.71,5.53L350.1,270.2,364,265.46l.25.7a31.62,31.62,0,0,0,4.54,3.59,8.8,8.8,0,0,0,2.71,1.21,13.5,13.5,0,0,0,3.66.55,1.14,1.14,0,0,1,1,1.91C375.36,274.1,372.24,274.46,368.79,273.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,274.47a8,8,0,0,1-1.71,1.71,23.82,23.82,0,0,1-4.93,3.16A23.46,23.46,0,0,1,357,281.2a8.43,8.43,0,0,1-2.41.27,33.25,33.25,0,0,0,14.59-7Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.4ace1bed441700f0362763327428a863.svg";
export { ForwardRef as ReactComponent };